import { combineReducers } from 'redux';

import certification from './certification/reducer';
import clinic from './clinic/reducer';
import certType from './certType/reducer';
import digi from './digi/reducer';

export default combineReducers({
  certification,
  clinic,
  certType,
  digi,
});
